import VueCookies from 'vue-cookies';
import {
  COOKIES_NAME,
} from './constants';
import {
  INITIALIZE_FROM_COOKIES, SET_ENTIDADE, SET_ENTIDADE_FROM_ID, SET_ENTIDADES, SET_LOADING,
} from './mutations.type';

export default {
  [SET_ENTIDADE](state, entidade) {
    state.entidade = entidade;
    state.idEntidade = entidade.id;
    // armazenamos somente o id da entidade no cookie
    VueCookies.set(COOKIES_NAME, entidade.id);
  },
  [SET_ENTIDADE_FROM_ID](state, idEntidade) {
    const entidade = state.entidades.find(e => Number(e.id) === Number(idEntidade));
    if (!entidade) {
      return;
    }
    state.idEntidade = idEntidade;
    state.entidade = entidade;
    VueCookies.set(COOKIES_NAME, idEntidade);
  },
  [SET_ENTIDADES](state, entidades) {
    state.entidades = entidades;
  },
  [INITIALIZE_FROM_COOKIES](state) {
    if (state.entidade && state.idEntidade) {
      return;
    }
    if (!state.entidades) {
      return;
    }
    state.idEntidade = VueCookies.get(COOKIES_NAME);
    state.entidade = state.entidades.find(e => Number(e.id) === Number(state.idEntidade));
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};
